import { ImageFormat } from '../../types/media';
import { FORMAT_LABELS } from '../../config/conversions';
import styles from './FormatBadge.module.css';

interface FormatBadgeProps {
  format: ImageFormat;
  variant?: 'from' | 'to' | 'neutral';
}

export default function FormatBadge({ format, variant = 'neutral' }: FormatBadgeProps) {
  return <span className={`${styles.badge} ${styles[variant]}`}>{FORMAT_LABELS[format]}</span>;
}
